{
  "name": "@artossoftware/stoq-sdk",
  "version": "0.6.0",
  "description": "STOQ preorders & back-in-stock for headless Shopify storefronts — typed client, React hooks for Hydrogen, drop-in script tag via jsDelivr, notify-me + preorder modals",
  "license": "MIT",
  "homepage": "https://docs.stoqapp.com/sdk/docs/headless/",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/fluke/restock.git",
    "directory": "packages/storefront-sdk"
  },
  "bugs": {
    "email": "support@stoqapp.com"
  },
  "type": "module",
  "main": "./dist/index.js",
  "module": "./dist/index.js",
  "types": "./dist/index.d.ts",
  "exports": {
    ".": {
      "types": "./dist/index.d.ts",
      "import": "./dist/index.js"
    },
    "./react": {
      "types": "./dist/react/index.d.ts",
      "import": "./dist/react/index.js"
    }
  },
  "unpkg": "./dist/stoq.min.js",
  "jsdelivr": "./dist/stoq.min.js",
  "files": [
    "dist",
    "docs",
    "README.md",
    "CHANGELOG.md"
  ],
  "sideEffects": [
    "./dist/stoq.min.js"
  ],
  "scripts": {
    "build": "rm -rf dist && tsup",
    "test": "vitest run",
    "test:watch": "vitest",
    "typecheck": "tsc --noEmit",
    "playground": "python3 -m http.server 4477",
    "smoke": "node scripts/smoke.mjs",
    "credentials:decrypt": "scripts/credentials decrypt",
    "credentials:encrypt": "scripts/credentials encrypt",
    "publish:npm": "scripts/credentials decrypt && yarn build && NPM_CONFIG_USERCONFIG=credentials/.npmrc npm publish --access public"
  },
  "keywords": [
    "stoq",
    "shopify",
    "preorder",
    "back-in-stock",
    "storefront"
  ],
  "peerDependencies": {
    "react": ">=18"
  },
  "peerDependenciesMeta": {
    "react": {
      "optional": true
    }
  },
  "devDependencies": {
    "@testing-library/dom": "^10.4.0",
    "@testing-library/react": "^16.1.0",
    "@types/react": "^18.3.12",
    "happy-dom": "^15.11.7",
    "react": "^18.3.1",
    "react-dom": "^18.3.1",
    "tsup": "^8.3.0",
    "typescript": "^5.6.0",
    "vitest": "^3.0.0"
  }
}
